import { Box, Card, Group, Image, rem, SimpleGrid, Space, Stack, Text, ThemeIcon, Title } from "@mantine/core"
import { IconBuilding } from "@tabler/icons-react"
import { footer, founderCardWithPhoto, mainHeader, personCard } from "../Common/Renders"

const directorsWithMessage: IPerson[] = [
  {
    id: 1,
    name: "Vijay Patel",
    role: "Founder, MD & CEO",
    message:
      "Dear Stakeholders, \n\nIt gives me immense pride to address you on behalf of our organization — a mission-driven enterprise committed to financial inclusion, integrity, and sustainable growth. Over the past years, our journey has been one of purpose and perseverance, guided by the belief that real change begins at the grassroots level.\nIn an evolving economic landscape, our focus has remained steadfast: to empower underserved communities through responsible and transparent financial services. Each milestone we’ve achieved is a reflection of the trust you’ve placed in us — and a testament to the hard work and dedication of our team.\n\nTo our investors, thank you for believing in our vision. Your support enables us to innovate and expand our reach, while staying true to our values.\nTo our employees, your passion, resilience, and commitment form the backbone of everything we do. You are not just professionals — you are changemakers.\nTo our partners and supporters, your collaboration fuels our momentum and reinforces the power of collective action.\n\nLooking ahead, we are excited about the possibilities that lie before us. We will continue to uphold the highest standards of governance, prioritize impact over intent, and grow responsibly — together.\n\nLet us continue to build a future where opportunity is not a privilege, but a promise we deliver on — for every individual, in every community we touch.\n\nWith gratitude.",
    image: "/people/md-cropped.jpg"
  }
]

const directors: IPerson[] = [
  {
    id: 2,
    name: "Manoj Kumar",
    role: "Co-Founder, MD & COO",
    message: "This is a quick sample intro about our directors, soon to be added."
  },
  {
    id: 3,
    name: "Jayati Devi",
    role: "Director",
    message: "This is a quick sample intro about our directors, soon to be added."
  },
  {
    id: 4,
    name: "Vijay Kumar",
    role: "Director",
    message: "This is a quick sample intro about our directors, soon to be added."
  }
]

const management = [
  { id: 1, name: "Shravan Patel", role: "Chief Finance Officer" },
  { id: 2, name: "Sumit Kumar", role: "HR Manager" },
  { id: 3, name: "Abhishek Patel", role: "Accounts Head" }
]

const companies = [
  {
    id: 1,
    name: "Uttam Rural Micro Benefit Foundation (registered under Section 8 of Companies Act 2013 )",
    established: "2019",
    description:
      "A non-profit organization providing small, unsecured loans to low-income families, women, and small businesses. With flexible repayment options and zero collateral, we help people meet daily needs, grow businesses, and handle emergencies — with dignity and confidence."
  },
  {
    id: 2,
    name: "JBR Micro Services Foundation (registered under Section 8 of Companies Act 2013)",
    established: "2023",
    description:
      "Focused on education, awareness, and self-employment support. From financial literacy to training programs, we help people learn, earn, and grow. JBR is our social impact arm, working to create stronger and smarter communities."
  },

  {
    id: 3,
    name: "Dharohar Creations Private Limited (registered Real Estate Company)",
    established: "2023",
    description:
      "Our vision for tomorrow — building affordable housing and community spaces that blend tradition with  modern living. Though in early stages, Dharohar Creations will focus on smart, eco-friendly, and people-centric development."
  }
]

export interface IPerson {
  id: number
  name: string
  role: string
  message?: string
  image?: string
}

export default function About(): React.ReactElement {
  return (
    <Box p={"md"}>
      {mainHeader()}

      <Space h={rem(32)} />

      <Text my="md" style={{ whiteSpace: "pre-line" }}>
        {
          "Dharohar Group is a mission-driven group working to improve lives in rural and small-town India. We believe that everyone deserves a fair chance to grow — no matter where they come from. \n\nOur name, Dharohar, means “Heritage”, and we are building a better future while staying rooted in our values. We focus on financial inclusion, community upliftment, and sustainable development. With years of experience and deep local understanding, we support people with small loans, skill-building, and access to opportunities that help them stand on their feet."
        }
      </Text>

      <Stack gap="md">
        <Title order={3}>Founders</Title>
        <SimpleGrid cols={{ base: 1, sm: 1 }}>
          {directorsWithMessage.map((person, index) => founderCardWithPhoto(index, person))}
        </SimpleGrid>
        <SimpleGrid cols={{ base: 1, sm: 2 }}>{directors.map((person, idx) => personCard(idx, person))}</SimpleGrid>
      </Stack>

      <Space h={rem(32)} />

      <Stack gap="md">
        <Title order={3}>Management Team</Title>
        <SimpleGrid cols={{ base: 1, sm: 2 }}>
          {management.map((person, index) => personCard(index, person))}
        </SimpleGrid>
      </Stack>

      <Space h={rem(32)} />

      <Title order={3} mb="md">
        Our Companies
      </Title>
      <SimpleGrid cols={{ base: 1, sm: 2 }}>
        {companies.map((company) => (
          <Card key={company.id} shadow="sm" radius="md" p="md" withBorder>
            <Group>
              <ThemeIcon variant="light" size={rem(48)} radius={rem(24)} color="violet">
                <IconBuilding size={24} />
              </ThemeIcon>
              <Stack gap={rem(4)}>
                <Text fw={600} mb="xs">
                  {company.name}
                </Text>
                <Text c="dimmed" size="sm" mb="xs">
                  {company.established}
                </Text>
                <Text size="sm">{company.description}</Text>
              </Stack>
            </Group>
          </Card>
        ))}
      </SimpleGrid>

      <Space h={rem(32)} />

      <Title order={3} mb="md">
        Our Partners
      </Title>

      <Group gap={rem(26)}>
        {[
          "/partners/yes-bank.png",
          "/partners/union-bank.png",
          "/partners/crif-highmark.png",
          "/partners/experian.png"
        ].map((partner, idx) => (
          <Image key={idx} src={partner} h={rem(32)} w={"auto"}></Image>
        ))}
      </Group>

      <Space h={rem(48)} />

      {footer()}
    </Box>
  )
}
